// ======================================================================
// File Name       : box
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/box';

export function receiveBoxList(recordNum, boxList) {
  return {
    type: ActionTypes.BOX_RECEIVE_BOX_LIST,
    recordNum,
    boxList,
  };
}

export function initDataForDetailEditConfirmDialog(boxSecernId, childItemSercernIdList) {
  return {
    type: ActionTypes.BOX_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG,
    boxSecernId,
    childItemSercernIdList: childItemSercernIdList || [],
  };
}

export function initDataForBoxRegisterDialog(boxSecernId) {
  return {
    type: ActionTypes.BOX_INIT_DATA_FOR_REGISTER_DIALOG,
    boxSecernId,
  };
}

export function handleInputChange(payload) {
  return {
    type: ActionTypes.BOX_INPUT_CHANGE,
    payload,
  };
}

export function changeData() {
  return {
    type: ActionTypes.BOX_CHANGE_DATA,
  };
}

export function getThumbnailDefault(data) {
  return {
    type: ActionTypes.BOX_GET_THUMBNAIL_DEFAULT,
    data,
  };
}

export function saveDetailSettingState(name, value) {
  return {
    type: ActionTypes.BOX_SAVE_DETAIL_SETTING_STATE,
    name,
    value,
  };
}
